import React from 'react';
import CardEasyFast from '../CardEasyFast/index';
import { Title, BoxEasyFast } from './style';


const EasyFast = () => (
	<BoxEasyFast>
		<Title>Veja como é fácil e rápido <br /> ter sua campanha</Title>
		<div className="row" style={{ marginBottom: '1px', padding: '0 23px' }}>
			<div className="d-flex justify-content-between col-12 col-lg-4 col-xl-4">
				<CardEasyFast
					number="1"
					altIcon=""
					titleIcon="Logo"
					text="Defina um objetivo, como ter mais visibilidade
                    ou gerar mais vendas de forma direta e até mesmo rever velhos amigos"
				/>
			</div>
			<div className="d-flex justify-content-between col-12 col-lg-4 col-xl-4">
				<CardEasyFast
					number="2"
					altIcon=""
					titleIcon="Alvo"
					title="A Era do"
					titleRed="e-commerce de carros"
					text="Depois de definir um objetivo, escolha por onde e quem alcançar.
                    Escolha um canal e defina seu público alvo"
				/>
			</div>
			<div className="d-flex justify-content-between col-12 col-lg-4 col-xl-4">
				<CardEasyFast
					number="3"
					altIcon=""
					titleIcon="Landing Page"
					title="Esteja além"
					titleRed="da concorrência"
					text="Agora que seus objetivos e forma de alcança-los foram definidos,
                    você decide o quanto investir. Lembre-se, invista da melhor forma!"
				/>
			</div>
		</div>
	</BoxEasyFast>
);

export default EasyFast;
